<div class="container-fluid" *ngIf="!isProgramacion">

  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a href="#/panel-admin" class="btn btn-primary">
                  Volver
              </a>
            </div>
            <h3 class="page-title">Planificación</h3>
        </div>
    </div>
  </div>
  <!-- end page title -->

  <div class="row">
    <div class="col-12">
        <div class="card" style="border-color: white;">
          <div class="card-body" style="margin-bottom: 150px;">

            <!-- Invoice Logo-->
            <div class="clearfix">
                <div class="float-start">
                  <div class="row">
                    <label for="ano" class="col-md-4 col-form-label">Año</label>
                    <div class="col-md-8">
                      <select class="form-select" id="ano" name="ano" (change)="onChangeYear($event)">
                        <option *ngFor="let op of years" [value]="op" [selected]="op == selectedYear ? true : false">
                          {{op}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
            </div>
            <hr class="text-dark">

            <div class="row">


              <div class="col-md-6 mt-4">
                <div class="card shadow-lg">
                  <h5 class="card-header color-primary text-light">Meta Programa PNA</h5>
                  <div class="card-body" style="margin-bottom: 5px;">
                    <h5 class="card-title text-center">{{resultado.total_meta_regional == null ? 0 : resultado.total_meta_regional}}</h5>
                  </div> <!-- end card-body-->
                  <div class="card-footer" style="background: #fff;">
                    <div class="d-grid gap-2">
                      <h6>Planificación {{selectedYear}}</h6>
                    </div>
                  </div>
                </div> <!-- end card-->
              </div> <!-- end col-->

              <div class="col-md-6 mt-4">
                <div class="card shadow-lg">
                  <h5 class="card-header color-primary text-light">Programación Docente</h5>
                  <div class="card-body">
                    <h5 class="card-title text-center">{{resultado.total_CFS == null ? 0 : resultado.total_CFS}}</h5>
                  </div> <!-- end card-body-->
                  <div class="card-footer" style="background: #fff;">
                    <div class="d-grid gap-2">
                      <ng-content *ngIf="validador"> <!-- *ngIf="validador && permissions.crearProgramacion" -->
                        <a style="cursor: pointer;" class="btn btn-sm btn-light border-dark" (click)="programar()">Agregar</a>
                      </ng-content>
                    </div>
                  </div>
                </div> <!-- end card-->
              </div> <!-- end col-->

            </div>


          </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>
  <!-- end row -->

</div>

<app-programacion *ngIf="isProgramacion"
  [year]="selectedYear"
  [user]="user"
  (subVolver)="volver($event)"
></app-programacion>

<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
